import React from 'react';
import { FaAward, FaLeaf, FaHardHat } from 'react-icons/fa';

import '../styles/standards.css';

/*
 * The three management standards Dofcan Oilserve's operational approach is
 * built around. Wording deliberately describes commitment and alignment -
 * the project holds no certification records for these standards, so
 * nothing here may read as a claim of certification.
 */
export const MANAGEMENT_STANDARDS = [
  {
    code: 'ISO 9001',
    name: 'Quality Management',
    principle: 'Quality',
    icon: <FaAward />,
    desc: 'Our commitment to consistent quality, continual improvement, and reliable service delivery.',
  },
  {
    code: 'ISO 14001',
    name: 'Environmental Management',
    principle: 'Environment',
    icon: <FaLeaf />,
    desc: 'Our commitment to responsible operations and reducing environmental impact.',
  },
  {
    code: 'ISO 45001',
    name: 'Occupational Health & Safety',
    principle: 'Health & Safety',
    icon: <FaHardHat />,
    desc: 'Our commitment to safer workplaces, responsible operations, and effective health and safety practices.',
  },
];

export default function StandardsSection({
  variant = 'section',
  eyebrow = 'Our Standards',
  title = 'Quality, Environment & Safety',
  intro = 'Our operational approach is built around three internationally recognised management standards, applied across our training, inspection, and certification work.',
  descriptions,
  note,
  className = '',
}) {
  const standards = MANAGEMENT_STANDARDS.map((standard, index) => ({
    ...standard,
    desc: descriptions?.[index] || standard.desc,
  }));

  if (variant === 'strip') {
    return (
      <div className={`standards-strip ${className}`.trim()}>
        {eyebrow && <span className="standards-strip-label">{eyebrow}</span>}

        <ul className="standards-strip-list">
          {standards.map((standard) => (
            <li key={standard.code} className="standards-strip-item">
              <span className="standards-strip-icon" aria-hidden="true">
                {standard.icon}
              </span>

              <div>
                <strong>{standard.code}</strong>
                <span className="standards-strip-name">{standard.name}</span>
                <p>{standard.desc}</p>
              </div>
            </li>
          ))}
        </ul>

        {note && <p className="standards-note">{note}</p>}
      </div>
    );
  }

  return (
    <section className={`standards-section ${className}`.trim()}>
      <div className="standards-container">
        <div className="standards-heading">
          {eyebrow && (
            <span className="standards-eyebrow">
              <span aria-hidden="true"></span>
              {eyebrow}
            </span>
          )}

          <h2>{title}</h2>

          {intro && <p>{intro}</p>}
        </div>

        <div className="standards-grid">
          {standards.map((standard) => (
            <article key={standard.code} className="standards-card">
              <div className="standards-card-top">
                <span className="standards-card-icon" aria-hidden="true">
                  {standard.icon}
                </span>

                <span className="standards-card-principle">
                  {standard.principle}
                </span>
              </div>

              <strong className="standards-card-code">{standard.code}</strong>

              <h3>{standard.name}</h3>

              <p>{standard.desc}</p>
            </article>
          ))}
        </div>

        {note && <p className="standards-note">{note}</p>}
      </div>
    </section>
  );
}
